exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellBooleanType[data-v-42632388] {\r\n  text-align: center;\n}\r\n", ""]);

// exports
